<template>
  <Html
    dir="ltr"
    lang="en"
  >
    <Body>
      <div>
        <ClientOnly>
          <AppBackground />
        </ClientOnly>
        <Transition>
          <LazyComicsComponent v-if="isComicsVisible" />
        </Transition>
        <div class="app-container">
          <AppHeader />
          <NuxtPage class="grow" />
          <AppFooter />
        </div>
      </div>
      <AppNotification />
    </Body>
  </Html>
</template>

<script setup>
import SettingApi  from '@/api/setting.js'

const config = useRuntimeConfig()
const ogImageUrl = `${config.public.appBaseUrl}/app_og_image.jpg`

useSeoMeta({
  ogSiteName: getContent('seo.meta_og_site_name'),
  locale: 'en_US',
  ogImage: ogImageUrl,
  twitterImage: ogImageUrl,
  imageAlt: getContent('seo.meta_og_image_alt'),
  keywords: getContent('seo.meta_keywords')
})

const isComicsVisible = useState(appStateConstants.IS_COMICS_VISIBLE)
const isSettingDataLoading = useState(appStateConstants.IS_SETTING_DATA_LOADING)
const settings = useState(appStateConstants.SETTINGS)

const { init: initTimer, clear: clearTimer } = useTimeLeft()

onMounted(async () => {
  try {
    const response = await SettingApi.getAll()

    settings.value = response
    const dateString = response?.token_sale_start_date
    
    if (!dateString) return 0

    initTimer(dateString) 
  } catch (error) {
    console.error('Download setting error: ', error)
  } finally {
    isSettingDataLoading.value = false
  }
})
onBeforeUnmount(clearTimer)

isSettingDataLoading.value = true
</script>

<style lang="scss">
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  position: relative;
}
</style>
